import {
	IModel,
	WPTerm,
	IWPTerm,
	IWPTermOptions,
} from "@/loader";

/**
 * Production Base Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * Do not modify it because it will be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.2.2
 * @since		1.0.0
 */
export interface IVIPProductionBase extends IWPTerm {}

/**
 * Production Base Options Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * Do not modify it because it will be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.2.2
 * @since		1.0.0
 */
export interface IVIPProductionOptions extends IWPTermOptions {}

/**
 * Production Base Class Logic.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * Do not modify it because it will be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.2.2
 * @since		1.0.0
 */
export class VIPProductionBase extends WPTerm implements IVIPProductionBase, IModel<IVIPProductionBase> {
	/**
	 * Constructor.
	 * @param data
	 */
	constructor (data: IVIPProductionBase = {}) {
		super(data);
	}

	/**
	 * Set all properties with the data provided or a default value.
	 *
	 * All properties will be set, either with the value provided or with their default value.
	 *
	 * If you want to set only a subset of this instance's properties, use {@link VIPProductionBase.update} instead.
	 *
	 * @param data
	 */
	public load(data: IVIPProductionBase) {
		super.load(data);
	}

	/**
	 * Set the properties with the data provided.
	 *
	 * Only the properties defined in data will be updated. Falsy values will be treated, only `undefined` is not.
	 *
	 * If you want to redefine all properties, use {@link VIPProductionBase.load} instead.
	 *
	 * @param data
	 */
	public update(data: IVIPProductionBase) {
		super.update(data);
	}
}
